import { render, staticRenderFns } from "./TrackerItem.vue?vue&type=template&id=a3b65812&scoped=true&"
import script from "./TrackerItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./TrackerItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TrackerItem.vue?vue&type=style&index=0&id=a3b65812&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b65812",
  null
  
)

export default component.exports